import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as MaintenanceStatusIcon } from "../../assets/icons/MaintenanceStatus.svg";
import { ReactComponent as MaintenanceHistoryIcon } from "../../assets/icons/MaintenanceHistory.svg";
import { ReactComponent as HomePlanIcon } from "../../assets/icons/HomePlan.svg";
import { ReactComponent as ContactIcon } from "../../assets/icons/Contact.svg";
import { ReactComponent as PrivacyIcon } from "../../assets/icons/Privacy.svg";
import { ReactComponent as TermsIcon } from "../../assets/icons/Terms.svg";
import { ReactComponent as LanguagesIcon } from "../../assets/icons/Languages.svg";
import { ReactComponent as ExitIcon } from "../../assets/icons/Exit.svg";
import { ReactComponent as RusIcon } from "../../assets/icons/Rus.svg";
import { ReactComponent as AzeIcon } from "../../assets/icons/Aze.svg";
import { ReactComponent as EngIcon } from "../../assets/icons/Eng.svg";
import { ReactComponent as MyHomeIcon } from "../../assets/icons/MyHome.svg";
import { ReactComponent as MyMasterIcon } from "../../assets/icons/MyMaster.svg";
import HeaderAccount from "../../components/HeaderAccount";
import DefaultProfileImage from "../../assets/images/default-profile-photo.jpg";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const Account = () => {
  const { t } = useTranslation();
  document.title = t("account.0");
  const backwardNavigate = "/home";
  const headerTitle = t("account.0");
  const storedUserInfo = JSON.parse(localStorage.getItem("user"));
  const [showExitModal, setShowExitModal] = useState(false);

  const exitAccount = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("authToken");
    setShowExitModal(false);
    window.location.assign("/home");
  };

  const handleShowExitModal = () => {
    setShowExitModal(true);
  };

  const handleCloseExitModal = () => {
    setShowExitModal(false);
  };
  const toggleLang = (lang) => {
    i18next.changeLanguage(lang);
  };
  return (
    <div className="account-section mx-3">
      <HeaderAccount title={headerTitle} backwardNavigate={backwardNavigate} />
      <div className="top-section">
        <div className="username-section d-flex gap-3 align-items-center justify-content-center">
          <div className="left-section">
            <img
              src={storedUserInfo?.image || DefaultProfileImage}
              alt="profile"
            />
          </div>
          <div className="right-section d-flex align-items-center justify-content-between w-100">
            <div className="name-user-section mt-3 d-flex flex-column">
              <div className="name-section">
                <h1>
                  {storedUserInfo?.name || "Ad"} &nbsp;
                  {storedUserInfo?.surname || "Soyad"}
                </h1>
              </div>
              <div className="user-section">
                <p>
                   {storedUserInfo?.phoneNumber || "Telefon nömrəsi yoxdur"}
                </p>
              </div>
            </div>
            <div className="detail-section me-2">
              <Link to="/account/details">
                <i className="fa-solid fa-chevron-right"></i>
              </Link>
            </div>
          </div>
        </div>
        <div className="maintenance-section d-flex align-items-center justify-content-between gap-3 ">
          <div
            className="section-1 section"
            style={{ cursor: "pointer" }}
            data-bs-toggle="modal"
            data-bs-target="#maintenanceStatus"
          >
            <MaintenanceStatusIcon />
            <h5>{t("account.2")}</h5>
          </div>
          <div className="section-2 section">
            <Link className="text-decoration-none" to="/account/repairhistory">
              <MaintenanceHistoryIcon />
              <h5>{t("account.3")}</h5>
            </Link>
          </div>
          <div className="section-3 section">
            <Link className="text-decoration-none" to="/account/homeplan">
              <HomePlanIcon />
              <h5>{t("account.4")}</h5>
            </Link>
          </div>
        </div>
      </div>
      <div className="middle-section">
        <div className="my-house-foreman-section mb-3">
          <div className="connection-section">
            <Link to="/account/myhome" className="text-decoration-none">
              <div className="section section-1 d-flex align-items-center">
                <div className="left-section">
                  <MyHomeIcon />
                </div>
                <div className="right-section d-flex align-items-center justify-content-between w-100">
                  <h2 className="mt-2">{t("account.5")}</h2>
                  <div className="detail-section me-2">
                    <i className="fa-solid fa-chevron-right"></i>
                  </div>
                </div>
              </div>
            </Link>
            <Link to="/account/myforeman" className="text-decoration-none">
              <div className="section section-2 d-flex align-items-center">
                <div className="left-section">
                  <MyMasterIcon />
                </div>
                <div className="right-section d-flex align-items-center justify-content-between w-100">
                  <h2 className="mt-2">{t("account.6")}</h2>
                  <div className="detail-section me-2">
                    <i className="fa-solid fa-chevron-right"></i>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
        <div className="connection-section">
          <Link to="/account/contact" className="text-decoration-none">
            <div className="section section-1 d-flex align-items-center">
              <div className="left-section">
                <ContactIcon />
              </div>
              <div className="right-section d-flex align-items-center justify-content-between w-100">
                <h2 className="mt-2">{t("account.7")}</h2>
                <div className="detail-section me-2">
                  <i className="fa-solid fa-chevron-right"></i>
                </div>
              </div>
            </div>
          </Link>
          <div
            className="section section-2 d-flex align-items-center"
            style={{ cursor: "pointer" }}
            data-bs-toggle="modal"
            data-bs-target="#languageModal"
          >
            <div className="left-section">
              <LanguagesIcon />
            </div>
            <div className="right-section d-flex align-items-center justify-content-between w-100">
              <h2 className="mt-2">{t("account.8")}</h2>
              <div className="detail-section me-2">
                <i className="fa-solid fa-chevron-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Languages */}
      <div
        className="modal fade"
        id="languageModal"
        tabIndex="-1"
        aria-labelledby="languageModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <ul className="list-group list-group-flush">
                <li
                  className="list-group-item"
                  data-bs-dismiss="modal"
                  onClick={() => toggleLang("az")}
                >
                  <AzeIcon />
                  <span className="ms-3">{t("account.9")}</span>
                  <hr className="mb-0 mt-3" />
                </li>
                <li
                  className="list-group-item"
                  data-bs-dismiss="modal"
                  onClick={() => toggleLang("en")}
                >
                  <EngIcon />
                  <span className="ms-3">{t("account.10")}</span>
                  <hr className="mb-0 mt-3" />
                </li>
                <li
                  className="list-group-item"
                  data-bs-dismiss="modal"
                  onClick={() => toggleLang("ru")}
                >
                  <RusIcon />
                  <span className="ms-3">{t("account.11")}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* Modal for maintenance status */}
      <div
        className="modal fade"
        id="maintenanceStatus"
        tabIndex="-1"
        aria-labelledby="maintenanceStatusLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <ul className="list-group list-group-flush">
                <li className="list-group-item" data-bs-dismiss="modal">
                  <input type="radio" id="customRadio" name="customRadio" />
                  <label className="ms-3">{t("account.12")}</label>
                  <hr className="mb-0 mt-3" />
                </li>
                <li className="list-group-item" data-bs-dismiss="modal">
                  <input type="radio" id="customRadio" name="customRadio" />
                  <label className="ms-3">{t("account.13")}</label>
                  <hr className="mb-0 mt-3" />
                </li>
                <li className="list-group-item" data-bs-dismiss="modal">
                  <input type="radio" id="customRadio" name="customRadio" />
                  <label className="ms-3">{t("account.14")}</label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-section">
        <h6 className="mb-2 ms-1">{t("account.15")}</h6>
        <div className="others-section">
          <Link to="/account/privacypolicy" className="text-decoration-none">
            <div className="section section-1 d-flex align-items-center">
              <div className="left-section">
                <PrivacyIcon />
              </div>
              <div className="right-section d-flex align-items-center justify-content-between w-100">
                <h2 className="mt-2">{t("account.16")}</h2>
                <div className="detail-section me-2">
                  <i className="fa-solid fa-chevron-right"></i>
                </div>
              </div>
            </div>
          </Link>
          <Link to="/account/terms" className="text-decoration-none">
            <div className="section section-2 d-flex align-items-center">
              <div className="left-section">
                <TermsIcon />
              </div>
              <div className="right-section d-flex align-items-center justify-content-between w-100">
                <h2 className="mt-2">{t("account.17")}</h2>
                <div className="detail-section me-2">
                  <i className="fa-solid fa-chevron-right"></i>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
      <div className="exit-section">
        <button
          className="btn w-100 p-0"
          type="button"
          onClick={handleShowExitModal}
        >
          <div className="section section-1 d-flex align-items-center">
            <div className="left-section">
              <ExitIcon />
            </div>
            <div className="right-section d-flex align-items-center justify-content-between w-100">
              <h2 className="mt-2">{t("account.20")}</h2>
              <div className="detail-section me-2">
                <i className="fa-solid fa-chevron-right"></i>
              </div>
            </div>
          </div>
        </button>
      </div>
      {showExitModal && (
        <div className="modal-overlay" onClick={handleCloseExitModal}>
          <div className="modal-content-custom" onClick={(e) => e.stopPropagation()}>
            <div className="modal-body">
              <h6 className="text-center my-auto">{t("account.19")}</h6>
            </div>
            <div className="exit-footer d-flex align-items-center justify-content-center gap-4 m-3">
              <button
                type="button"
                className="btn exit-button"
                onClick={exitAccount}
              >
                {t("account.20")}
              </button>
              <button
                type="button"
                className="btn cancel-button"
                onClick={handleCloseExitModal}
              >
                {t("account.21")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Account;
